import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from "react";
import { Chip, Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";

export const StationsComponent = ({
  stations = false,
  multi = false,
  enableSelectAll = false,
  state,
  limitTags,
  gridWidth,
  dispatchAction = () => null
}) => {
  const { stationsList } = useSelector(({ companies }) => companies);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!enableSelectAll) {
      if (stations && dispatchAction && !state?.station && !multi) {
        dispatch(dispatchAction("station", stationsList[0]));
      } else if (stations && dispatchAction && !state?.station && multi) {
        dispatch(dispatchAction("station", []));
      }
    }
  }, []);

  // Modo con select all: plantas derivadas de las empresas seleccionadas
  if (enableSelectAll) {
    const selectedCompanies = state?.company || [];
    const stationOptions = (
      selectedCompanies.length
        ? selectedCompanies.flatMap((comp) => comp?.stations || [])
        : stationsList
    ).map((st) => ({ ...st, label: st.fullName || st.label }));

    const handleStationChange = ({ station }) => {
      dispatch(dispatchAction("station", station || []));
    };

    return (
      <Grid item xs={12} sm={3} md={gridWidth}>
        <AutocompleteComponent
          label="Plantas"
          name="station"
          value={state?.station || []}
          handleValues={handleStationChange}
          options={stationOptions}
          multiple
          enableSelectAll
          allLabel="Todas las plantas"
          limitTags={limitTags || 2}
          size="small"
          fullWidth
          variant="outlined"
        />
      </Grid>
    );
  }

  // Modo original
  return (
    <Grid item xs={12} sm={3} md={gridWidth}>
      <Autocomplete
        id="combo-box-demo"
        filterSelectedOptions
        options={stationsList}
        value={state?.station || null}
        defaultValue={stationsList[0] || null}
        getOptionLabel={(option) => option?.label || ""}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option.label}
              {...getTagProps({ index })}
              style={{
                borderRadius: 4,
              }}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Planta"
            variant="outlined"
            size="small"
          />
        )}
        fullWidth
        onChange={(e, v) => dispatch(dispatchAction("station", v))}
        noOptionsText="No se encuentra la planta"
        limitTags={limitTags}
        multiple={multi}
      />
    </Grid>
  );
};
